import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';
import { defaultClueQueryLimit, requiredCoordinates } from '../../../constant/clue';

export const REQUEST_CREATE_REWARD_ITEM = 'REQUEST_CREATE_REWARD_ITEM';
export const REQUEST_CREATE_REWARD_ITEM_SUCCESS = 'REQUEST_CREATE_REWARD_ITEM_SUCCESS';
export const REQUEST_CREATE_REWARD_ITEM_FAILURE = 'REQUEST_CREATE_REWARD_ITEM_FAILURE';

const defaultState = {
    creatingRewardItem: false,
    failedCreatingRewardItem: false,
    };


const reducer = createReducer(defaultState, {
    [REQUEST_CREATE_REWARD_ITEM]: (state) => ({
        ...state,
        creatingRewardItem: true,
        failedCreatingRewardItem: false,
    }),
    [REQUEST_CREATE_REWARD_ITEM_SUCCESS]: (state) => ({
        ...state,
        creatingRewardItem: false,
        failedCreatingRewardItem: false,
    }),
    [REQUEST_CREATE_REWARD_ITEM_FAILURE]: (state) => ({
        ...state,
        creatingRewardItem: false,
        failedCreatingRewardItem: true,
    }),
});

export default reducer;
export const namespace = 'rewardItems';

export const createRewardItemApi = (payload) => async (dispatch, getState) => {
    return await callAPI({
        method: 'post',
        apiPath: '/reward-items',
        actionTypes: [REQUEST_CREATE_REWARD_ITEM, REQUEST_CREATE_REWARD_ITEM_SUCCESS, REQUEST_CREATE_REWARD_ITEM_FAILURE],
        variables: payload,
        dispatch,
        getState,
    });
}
